import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './EntityPageUnfollowMutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityPageUnfollowMutationVariables = Types.Exact<{
  followedId: Types.Scalars['ID']['input'];
}>;


export type EntityPageUnfollowMutation = (
  { __typename?: 'Mutation' }
  & { entityPageUnfollow?: Types.Maybe<(
    { __typename?: 'FollowersMutationResult' }
    & { error?: Types.Maybe<(
      { __typename?: 'FollowersFollowError' }
      & Pick<Types.FollowersFollowError, 'message'>
    )> }
  )> }
);


export type EntityPageUnfollowMutationFn = Apollo.MutationFunction<EntityPageUnfollowMutation, EntityPageUnfollowMutationVariables>;

/**
 * __useEntityPageUnfollowMutation__
 *
 * To run a mutation, you first call `useEntityPageUnfollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityPageUnfollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityPageUnfollowMutation, { data, loading, error }] = useEntityPageUnfollowMutation({
 *   variables: {
 *      followedId: // value for 'followedId'
 *   },
 * });
 */
export function useEntityPageUnfollowMutation(baseOptions?: Apollo.MutationHookOptions<EntityPageUnfollowMutation, EntityPageUnfollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityPageUnfollowMutation, EntityPageUnfollowMutationVariables>(Operations.EntityPageUnfollow, options);
      }
export type EntityPageUnfollowMutationHookResult = ReturnType<typeof useEntityPageUnfollowMutation>;
export type EntityPageUnfollowMutationResult = Apollo.MutationResult<EntityPageUnfollowMutation>;
export type EntityPageUnfollowMutationOptions = Apollo.BaseMutationOptions<EntityPageUnfollowMutation, EntityPageUnfollowMutationVariables>;